import { useEffect, useState } from "react";
import axios from "axios";
import { TrackStatusFormField } from "@/modules/property-tracks/dtos/property-stage";

export interface DynamicOption {
  label: string;
  value: string | number;
}

function extractArrayPayload(body: unknown, path?: string | null): unknown[] {
  if (Array.isArray(body)) {
    return body;
  }
  if (body !== null && typeof body === "object" && path?.trim()) {
    const key = path.trim();
    const value = (body as Record<string, unknown>)[key];
    return Array.isArray(value) ? value : [];
  }
  return [];
}

/**
 * Fetches options for Dynamic field types (external HTTP).
 */
export const useDynamicFieldOptions = (field?: TrackStatusFormField | null) => {
  const [options, setOptions] = useState<DynamicOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (!field?.dynamicFormUrl) {
          setOptions([]);
          return;
        }

        setLoading(true);

        const response = await axios.get(field.dynamicFormUrl);
        const rows = extractArrayPayload(response.data, field.dynamicFormPath);

        const labelKey = field.dynamicFormLabel ?? "label";
        const valueKey = field.dynamicFormValue ?? "value";

        const mapped: DynamicOption[] = rows.map((item: any) => ({
          label: String(item[labelKey] ?? ""),
          value: item[valueKey],
        }));

        setOptions(mapped);
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [
    field?.dynamicFormUrl,
    field?.dynamicFormPath,
    field?.dynamicFormLabel,
    field?.dynamicFormValue,
  ]);

  return { options, loading };
};
